import type {IconName} from '@lightricks/react-design-system';

export type PrepKind = 'shipping' | 'gift-code';

export interface PrepStatusPresentation {
  title: string;
  descriptionHtml?: string;
  iconName: IconName;
  iconAppearance: 'neutral' | 'brand' | 'danger';
}

const SHIPPING: Record<string, PrepStatusPresentation> = {
  awaiting_fulfillment: {
    title: 'Awaiting Shipping Details',
    descriptionHtml:
      "We're waiting for the shipping information to send along the product for this gig. Hang tight and we'll update you soon.",
    iconName: 'Actions-Info-Line',
    iconAppearance: 'neutral',
  },
  en_route: {
    title: 'In transit',
    descriptionHtml:
      "The product for this gig is headed your way. Check the tracking info below. Have questions? <a href='https://help-popularpays.lightricks.com/hc/en-us/articles/24970366321298-The-shipping-information-for-my-gig-product-wasn-t-recognized-by-the-system-What-do-I-do' target='_blank'>Learn more here</a>.",
    iconName: 'Actions-Forward-Line',
    iconAppearance: 'neutral',
  },
  fulfilled: {
    title: 'Delivered',
    iconName: 'Actions-Accept',
    iconAppearance: 'brand',
  },
  info: {
    title: 'Shipping Info Provided',
    descriptionHtml:
      "Our system doesn't support tracking this shipment method, but check the tracking info below for updates.",
    iconName: 'Actions-Info-Line',
    iconAppearance: 'neutral',
  },
  exception: {
    title: 'Exception',
    descriptionHtml:
      '<em>Signature not received.</em><br>Send us a message with any questions.',
    iconName: 'Actions-Alert-Fill',
    iconAppearance: 'danger',
  },
};

const GIFT_CODE: Record<string, PrepStatusPresentation> = {
  awaiting_fulfillment: {
    title: 'Awaiting Gift Code',
    descriptionHtml:
      "We're waiting on the brand to send the gift code you can use to get the product for this gig. We'll update you soon.",
    iconName: 'Actions-Info-Line',
    iconAppearance: 'neutral',
  },
  fulfilled: {
    title: 'Gift Code Ready',
    iconName: 'Actions-Accept',
    iconAppearance: 'brand',
  },
};

export const FULFILLED_STATE = 'fulfilled';

export function prepStatusPresentation(
  kind: PrepKind,
  state: string
): PrepStatusPresentation | undefined {
  return (kind === 'shipping' ? SHIPPING : GIFT_CODE)[state];
}

const CARRIER_NAMES: Record<string, string> = {
  ups: 'UPS',
  usps: 'USPS',
  fedex: 'FedEx',
  unknown_carrier: 'Unknown Carrier',
  no_carrier: '',
};

export const UNKNOWN_CARRIER = 'unknown_carrier';

export function carrierName(carrier: string | null): string {
  if (!carrier) return '';
  return CARRIER_NAMES[carrier] ?? carrier;
}
